import { useQuery } from '@apollo/client'
import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import { PASTAS_PERMISSAO_ESCRITA } from '../data/pastas-permissao-escrita'
import { GetPastaPermissaoEscritaQueryQuery } from '@/core/types/graphql'

const useDataToSelect = ({ items }) => {
  const { data, loading } =
    useQuery<GetPastaPermissaoEscritaQueryQuery>(PASTAS_PERMISSAO_ESCRITA, {
      fetchPolicy: 'cache-and-network'
    }) ?? {}

  const dataToSelect = useMemo(() => {
    const toSelect = data?.pastasComPermissaoEscrita?.filter(obj =>
      items !== null
        ? !items.some(item => item.id === obj?.id) &&
          !items.some(item => item.pastaPai?.id === obj?.id)
        : obj
    )

    if (
      items !== null &&
      items.some(item => item.isPasta && item.pastaPai !== null)
    ) {
      return [...toSelect, { id: '0', nome: t`Biblioteca` }]
    }

    return toSelect
  }, [data?.pastasComPermissaoEscrita, items])

  return {
    dataToSelect,
    loading
  }
}

export default useDataToSelect
